import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAlert,{staticClass:"mt-0",staticStyle:{"font-size":"15px","color":"rgba(0, 0, 0, 0.6) !important"},attrs:{"id":"video-hint-info","text":"","filled":"","dense":"","color":"grey"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('a',{staticClass:"ml-1 more-info",attrs:{"href":_vm.link == null
        ? 'https://quick-bowl-4e0.notion.site/Hilfestellungen-8ef599630ef740b2af7657847cdb8857#b7c3e807fb5646c2b7ec462f756d94ee'
        : _vm.link,"target":"_blank"}},[_vm._v("Mehr Informationen...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }